import { defineMessages } from 'react-intl';

/** design: onboarding h3. `{plan}` is the name of the plan the trial gives (`MUSIC24_TRIAL_LEVEL_TIER`). */
export const trialStatusMessages = defineMessages({
  runningTitle: { id: 'app.sml.trialStatus.running.title', defaultMessage: 'Days of {plan} left' },
  runningLine: { id: 'app.sml.trialStatus.running.line', defaultMessage: 'Finish your release' },
  noSongLine: { id: 'app.sml.trialStatus.noSong.line', defaultMessage: 'Add your first song' },
  lastDayTitle: { id: 'app.sml.trialStatus.lastDay.title', defaultMessage: 'Last day of {plan}' },
  lastDayLine: { id: 'app.sml.trialStatus.lastDay.line', defaultMessage: 'Keep the full files' },
  endedTitle: { id: 'app.sml.trialStatus.ended.title', defaultMessage: 'You are on Free now' },
  endedLine: { id: 'app.sml.trialStatus.ended.line', defaultMessage: 'Nothing was charged' },
  endedTile: { id: 'app.sml.trialStatus.ended.tile', defaultMessage: 'Free' },
  // The top-bar chip of the web left with navigation v2. The native apps still read these ids.
  chipDays: {
    id: 'app.sml.trialStatus.chip.days',
    defaultMessage: '{days, plural, one {# day} other {# days}}',
  },
  chipLastDay: { id: 'app.sml.trialStatus.chip.lastDay', defaultMessage: 'Last day' },
  chipEnded: { id: 'app.sml.trialStatus.chip.ended', defaultMessage: 'Free' },
  seePlans: { id: 'app.sml.trialStatus.seePlans', defaultMessage: 'See plans' },
  switcherTrial: { id: 'app.sml.trialStatus.switcher', defaultMessage: '{plan} trial' },
});
